import axios from '../axios';

const fetchFlowFolders = async (botId: string) => {
  const { data } = await axios.get(`/flows/${botId}/folders`);

  return data;
};

export default fetchFlowFolders;
